"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

const OKDateTabs = ({ selectedDate, onDateChange, compact }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Kèo trực tuyến",
      dateLabel: today.format("DD-MM"),
      type: "live",
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      dateLabel: today.format("DD-MM"),
      type: "today",
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      dateLabel: tomorrow.format("DD-MM"),
      type: "tomorrow",
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD-MM"),
        type: "future",
      });
    }

    return options;
  }, [todayString]);

  return (
    <div
      className={`flex w-full ${compact ? "h-full min-h-0 items-stretch" : "items-center mb-4 mt-2 md:mb-6 md:mt-4"}`}
    >
      <div className="flex h-full w-full min-w-0 gap-2 overflow-x-auto overflow-y-hidden items-center">
        {dateOptions.map((opt) => {
          const isSelected = selectedDate === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onDateChange(opt.value)}
              className={`flex h-11 min-w-14 shrink-0 flex-col items-center justify-center rounded-lg border text-sm font-normal leading-none kbv-shadow-subtle max-[1056px]:h-[34px] max-[1056px]:py-1 px-2 ${isSelected
                ? "border-[var(--theme-primary)] bg-[var(--theme-primary)] text-white"
                : "kbv-border-lighter kbv-bg-white kbv-text-gray"
                }`}
            >
              <span className="font-medium">{opt.label}</span>
              {opt.type !== "live" && opt.dateLabel && (
                <span className="text-sm mt-0.5 opacity-70">{opt.dateLabel}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OKDateTabs;